module.exports = __webpack_public_path__ + "static/media/tarjeta-eroski-cupon.2d912195.png";